import { useHistory } from 'react-router';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/addUserDialogStyle';
import { makeStyles } from '@material-ui/core';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { translate } from 'components/Translation';
import { BodyM, Caption } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Button from 'components/CustomButtons/Button';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IConfirmationProps {
	hideDialog: () => void;
	userName: string;
	userType: types.users.userType;
	userId: string;
}

const Confirmation = ({ hideDialog, userName, userType, userId }: IConfirmationProps) => {
	const history = useHistory();
	const classes = useStyles();
	return (
		<CustomConfirmationDialog
			isOpen
			hideDialog={() => hideDialog()}
			header={
				<>
					<BodyM>{translate('add.user.newUserAdded')}</BodyM>
					<p className={classes.userName}>{userName}</p>
					<ConditionalRender
						show={['MANAGER', 'ADMIN'].includes(userType)}
						onTrue={() => (
							<div className={classes.userWillReceive}>
								<Caption>{translate('add.user.userWillReceiveEmail')}</Caption>
							</div>
						)}
					/>
					<Button
						fullWidth
						color="tertiary-light"
						onClick={() => history.push(`/dashboard/users/${userId}/numbers`)}
					>
						{translate('add.user.add.number')}
					</Button>
				</>
			}
		/>
	);
};

export default Confirmation;
